module.exports = __webpack_public_path__ + "static/media/back_arrow.e00b58a4.svg";